module.exports = __webpack_public_path__ + "media/images/top/search/img_zeirishi-812186097a65684eb9c9cd748a3a1b60.png";